
import '@/assets/scss/index.scss'

import { pdMixin } from '@/mixin/pd/pdMixin'
import InfiniteScroll from '@/components/common/scroll/InfiniteScroll.vue'
import { getCapturedImageUrl } from '~/scriptData/common/interM2'
import CommonImage from '~/components/common/CommonImage.vue'

export default {
  components: {
    CommonImage,
    InfiniteScroll
  },
  mixins: [pdMixin],
  props: {
    isSelRevwCttsReload: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      pdNo: this.$route.query.pdNo, // 상품번호
      visible: false,
      data: {}, // 부모창에서 가져온 데이터
      cttsList: [], // 컨텐츠 리스트
      selOpt: { // 컨텐츠 리스트 조회 옵션
        pageSize: 24, // 한페이지 당 노출 건수
        currentPage: 1 // 조회 페이지
      },
      totalCnt: 0, // 리뷰 토탈 갯수
      currentPage: 1, // 현재 페이지
      loadDisabled: true // 인피니티 스크롤 로드 disabled
    }
  },
  watch: {
    visible (flag) {
      this.selOpt.currentPage = 1
      this.cttsList = []
      if (flag) {
        this.selRevwCtts(false) // 컨텐츠 리스트 불러오기
      }
    },
    isSelRevwCttsReload (val) {
      if (val) {
        this.loadMore()
        this.$emit('selRevwCttsReload')
      }
    }
  },
  created () {

  },
  mounted () {
    this.selRevwCtts(false) // 컨텐츠 리스트 불러오기
  },
  methods: {
    getCapturedImageUrl,

    // 컨텐츠 리스트 불러오기
    async selRevwCtts (reload) {
      try {
        await this.$AxiosBuilder
          .data({ pdNo: this.pdNo, ...this.selOpt })
          .build()
          .post('/pd/pds/revw/selRevwCtts')
          .then((res) => {
            if (res.data.success) {
              const result = res.data.data

              if (!reload) {
                this.cttsList = []
                this.totalCnt = result.length === 0 ? 0 : result[0].totalCnt // 리뷰 토탈 갯수
                // 전체 건수가 한 페이지 로드 건수보다 같거나 적으면 스크롤 이벤트 disabled = true
                this.loadDisabled = this.totalCnt <= this.selOpt.pageSize
              }
              if (result.length) {
                this.cttsList.push(...result)
                this.currentPage = this.selOpt.currentPage // 현재 페이지 셋팅
                // 로드된 건수와 전체건수 비교해서 스크롤 이벤트 활성화
                this.loadDisabled = this.totalCnt <= this.cttsList.length
              } else {
                this.cttsList = []
                this.totalCnt = 0
                this.loadDisabled = true
              }
              this.$emit('revwCttsList', { cttsList: this.cttsList, totalCnt: this.totalCnt })
            } else {
              this.alert(res.data.message)
            }
          })
      } catch (e) {
        console.log('LayerRevwCttsClt selRevwCtts error : ', e)
      }
    },

    // 스크롤 하단 이동 시 다음 페이지 로드
    loadMore () {
      this.loadDisabled = true
      this.selOpt.currentPage = this.currentPage + 1
      this.selRevwCtts(true) // 리로드 여부 true
    },

    // 팝업 닫기
    close () {
      this.visible = false
    },

    // 리뷰 상세 팝업
    openLayerRevwDtl (revwMngNo) {
      this.$emit('openLayerRevwDtl', { name: 'revwDtl', data: { revwMngNo } })
    }
  }
}
